import React from "react";
import { Box } from "@mui/material";
import { Delete } from "@mui/icons-material";
import type { ConfigMode } from "../../Context/types";
import * as Styled from "../../styles";

interface ActionButtonsProps {
  mode: ConfigMode;
  isLoading: boolean;
  internalReadOnly: boolean;
  showReview: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onDelete: () => void;
  onPrimaryAction: () => void;
  getButtonText: () => string;
  getLoadingText: () => string;
}

function ActionButtons({
  mode,
  isLoading,
  internalReadOnly,
  showReview,
  onEdit,
  onCancel,
  onDelete,
  onPrimaryAction,
  getButtonText,
  getLoadingText,
}: ActionButtonsProps) {
  return (
    <Box display="flex">
      <Styled.ButtonsContainer>
        {mode === "EDIT" && !showReview && (
          <Styled.DeleteButton
            variant="contained"
            endIcon={<Delete />}
            onClick={onDelete}
            disabled={isLoading}
          >
            Excluir
          </Styled.DeleteButton>
        )}
        <Box display="flex" gap={1} width="100%" justifyContent="flex-end">
          {showReview && (
            <Styled.EditButton
              variant="outlined"
              color="inherit"
              onClick={onEdit}
              disabled={isLoading}
              sx={{ height: "42px" }}
            >
              Editar
            </Styled.EditButton>
          )}

          {!showReview &&
            (internalReadOnly ? (
              <Styled.EditButton
                variant="outlined"
                color="inherit"
                onClick={onEdit}
                disabled={isLoading}
                sx={{ height: "42px" }}
              >
                Editar
              </Styled.EditButton>
            ) : (
              <Styled.CancelButton
                variant="outlined"
                onClick={onCancel}
                sx={{ height: "42px" }}
              >
                Cancelar
              </Styled.CancelButton>
            ))}
          <Styled.PrimaryButton
            variant="contained"
            color="primary"
            onClick={onPrimaryAction}
            disabled={isLoading}
          >
            {isLoading ? getLoadingText() : getButtonText()}
          </Styled.PrimaryButton>
        </Box>
      </Styled.ButtonsContainer>
    </Box>
  );
}

export default ActionButtons;
